import { css } from '@linaria/core';
import { styled } from '@linaria/react';

import { Text } from '~components/Typography';

export const StyledPExplore = styled(Text)`
	min-width: 142px;
	text-align: left;
`;

export const styledDropdownElement = css`
	display: flex;
	height: auto;
	min-height: 40px;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	gap: 0 !important;
`;

export const Wrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
`;
